import { FC } from 'react';

import Button from '@/components/controls/Button.tsx';

type VoucherDetailsButtonsProps = {
  onGeneratePDF: () => void;
};

const VoucherDetailsActionButtons: FC<VoucherDetailsButtonsProps> = ({
  onGeneratePDF,
}: VoucherDetailsButtonsProps) => {
  return (
    <div className="flex justify-end my-2">
      <Button
        buttonStyle="bg-primary-100 hover:bg-primary-200 border border-primary-100 text-white py-2 px-4 rounded-lg"
        text="Generate PDF"
        buttonType={{ type: 'button' }}
        hasImage={false}
        onClick={onGeneratePDF}
      />
    </div>
  );
};

export default VoucherDetailsActionButtons;
